<template>
    <div
        class="floating-form"
        ref="floating"
        v-if="showFloatingEl"
        :style="floatingStyles"
    >
        <slot :onSubmit="handleComplete" :dispatch="dispatch" :graphic="graphic"></slot>
    </div>
</template>

<script setup>
import { ref, onMounted, useAttrs } from "vue";
import { autoPlacement, offset, useFloating } from "@floating-ui/vue";

const showFloatingEl = ref(false);
const isDisplay = ref(false);
const reference = ref(null);
const floating = ref(null);
const attrs = useAttrs();

const { floatingStyles } = useFloating(reference, floating, {
    middleware: [
        offset(5),
        autoPlacement({
            alignment: "right",
        }),
    ],
});

let graphic = ref(null);
let context = null;
let callback = () => {};

const props = defineProps(["openEvent", "closeEvent"]);

onMounted(() => {
    document.addEventListener(props.openEvent, handleOpenSlot);

    document.addEventListener(props.closeEvent, function () {
        showFloatingEl.value = false;
    });
});

function handleOpenSlot(evt) {
    callback = evt?.detail?.callback ?? callback;

    showFloatingEl.value = true;
    graphic.value = evt.detail?.graphic;
    let layer = evt.detail?.layer;

    var { x, y } = view.toScreen(graphic.value.geometry);
    const clientX = x;
    const clientY = y;

    reference.value = {
        getBoundingClientRect() {
            return {
                width: 0,
                height: 0,
                x: clientX,
                y: clientY,
                left: clientX,
                right: clientX,
                top: clientY,
                bottom: clientY,
            };
        },
    };

    document.dispatchEvent(new CustomEvent('floating-panel-open', {
        detail: {
            attrs,
        }
    }))
}

function handleComplete() {
    // let the other end of the app handle this
    let ok = callback(graphic);

    if (ok) {
        showFloatingEl.value = false;
    }
}

function dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, {
        detail: {
            data
        }
    }));
}
</script>

<style scoped>
.floating-form {
    position: absolute;
    /* background: white; */
    box-sizing: border-box;
    top: 500px;
    right: 300px;
    width: 300px;
    border-radius: 10px;
}
</style>
